import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  Col,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
} from "antd";
import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { newGlAccountAction } from "../../../redux/actions";
import { staticConfig } from "../glAndAccounting.config";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const AddGLA0100 = (props) => {
  //DECLARED VARIABLES
  const {
    userData,
    onSelectItemAction,
    rightBtn,
    rightAction,
    getGlListAction,
    newGlAccountAction,
  } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newGLItems, statusData } = appStatic;

  const [accountTypeData, setAccountTypeData] = useState([]);
  const [parentData, setParentData] = useState([]);
  const [accountUsageData, setAccountUsageData] = useState([]);
  const [accountTagData, setAccountTagData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [manualEntriesAllowed, setManualEntriesAllowed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [glAccTemplate, setGlAccTemplate] = useState({});
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [glCodeLengthLoading, setGlCodeLengthLoading] = useState(false);
  const [glCodeLength, setGlCodeLength] = useState(1);

  // Watch the account type field for changes
  const selectedAccountType = Form.useWatch("type", form);

  useEffect(() => {
    getTemplate();
    getGlcodeLength();
  }, []);

  // Effect to handle account type changes and update parent/tag data
  useEffect(() => {
    if (selectedAccountType && glAccTemplate) {
      updateParentAndTagData(selectedAccountType);
      // Clear the parent and tag fields when account type changes
      form.setFieldsValue({
        parentId: undefined,
        tagId: undefined,
      });
    }
  }, [selectedAccountType, glAccTemplate]);

  const updateParentAndTagData = (accountTypeId) => {
    // Find the account type option to get its label
    const accountTypeOption = accountTypeData.find(
      (option) => option.value === accountTypeId
    );

    if (!accountTypeOption) return;

    const accountTypeLabel = accountTypeOption.label.toLowerCase();

    let parentOptions = [];
    let tagOptions = [];

    switch (accountTypeLabel) {
      case "asset":
        parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
        break;

      case "liability":
        parentOptions = getOptionsFromTemplate("liabilityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedLiabilitiesTagOptions");
        break;

      case "equity":
        parentOptions = getOptionsFromTemplate("equityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedEquityTagOptions");
        break;

      case "expense":
        parentOptions = getOptionsFromTemplate("expenseHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedExpensesTagOptions");
        break;

      case "income":
        parentOptions = getOptionsFromTemplate("incomeHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedIncomeTagOptions");
        break;

      case "contingent_asset":
        parentOptions = getOptionsFromTemplate(
          "contingentAssetHeaderAccountOptions"
        );
        tagOptions = getOptionsFromTemplate(
          "allowedContingentAssetsTagOptions"
        );
        break;

      case "contingent_liability":
        parentOptions = getOptionsFromTemplate(
          "contingentLiabilityHeaderAccountOptions"
        );
        tagOptions = getOptionsFromTemplate(
          "allowedContingentLiabilitiesTagOptions"
        );
        break;

      default:
        parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
        break;
    }

    setParentData(parentOptions);
    setAccountTagData(tagOptions);
  };

  const getOptionsFromTemplate = (templateKey) => {
    if (!glAccTemplate[templateKey]) return [];

    return glAccTemplate[templateKey].map((element) => ({
      value: element.id,
      label: element.name,
    }));
  };

  function onCancel() {
    navigate("/gla0100", { replace: false });
  }

  function getTemplate() {
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, definedApi.GlAccountTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        setGlAccTemplate(res);
        let tempAccountType = [];
        let tempAccountUsage = [];
        let tempCurrency = [];

        objList?.accountTypeOptions?.forEach((element) => {
          tempAccountType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.usageOptions?.forEach((element) => {
          tempAccountUsage.push({
            value: element.id,
            label: element.value,
          });
        });

        // Add "All" option first, then add other currencies
        tempCurrency.push({
          value: "ALL",
          label: "All Currencies",
        });

        objList?.currencies?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        // Set default account type
        // if (
        //   objList?.accountTypeOptions &&
        //   objList.accountTypeOptions.length > 0
        // ) {

        // }

        form.setFieldsValue({
          type: objList.accountTypeOptions[0].id,
          manualEntriesAllowed: staticConfig.yesOrNo[0].value,
          status: statusData[0].value,
          usage: tempAccountUsage[0].value,
          currencyCode: tempCurrency[1].value,
        });

        setAccountTypeData(tempAccountType);
        setAccountUsageData(tempAccountUsage);
        setCurrencyData(tempCurrency);
        setIsLoading(false);
      }
    });
  }

  function getGlcodeLength() {
    setGlCodeLengthLoading(true);
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      definedApi.GlAccountCodeLengthConfig,
      (err, res) => {
        setGlCodeLengthLoading(false);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err);
        } else {
          console.log(res);
          setGlCodeLength(res?.value ?? 0);
        }
      }
    );
  }
  // Add this handler function for currency change
  const handleCurrencyChange = (value) => {
    setSelectedCurrency(value);
  };

  const handleManuelEntriesAllowed = (e) => {
    setManualEntriesAllowed(e.target.checked);
  };

  const onSubmit = (formValues) => {
    // formValues.manualEntriesAllowed = manualEntriesAllowed;

    // Remove currencyCode from payload if "All" is selected
    if (selectedCurrency === "ALL" || formValues.currencyCode === "ALL") {
      delete formValues.currencyCode;
    }

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    // console.log(body)
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      definedApi.NewGlAccount,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.newGLCreatedMsg);
          navigate("/gla0100");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/gla0100");
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent pageTitle={appLabel.newGLAccount} pageItems={newGLItems} />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="type"
                    label={<Text strong>{appLabel.accountType}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.accountType),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.accountType
                      )}
                      showSearch
                      options={accountTypeData}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="parentId"
                    label={<Text strong>{appLabel.parent}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(appLabel.parent)}
                      showSearch
                      options={parentData}
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      allowClear
                      key={selectedAccountType} // Force re-render when account type changes
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="glCode"
                    label={<Text strong>{appLabel.GLCode}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.GLCode),
                      },
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                          if (value.length < glCodeLength) {
                            return Promise.reject(
                              new Error(
                                `GL Code must be ${glCodeLength} characters long`
                              )
                            );
                          }

                          if (value.length > glCodeLength) {
                            return Promise.reject(
                              new Error(
                                `Value must not exceed ${glCodeLength} characters`
                              )
                            );
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(appLabel.GLCode)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="name"
                    label={<Text strong>{appLabel.accountName}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.accountName),
                      },
                    ]}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.accountName
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="usage"
                    label={<Text strong>{appLabel.accountUsage}</Text>}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: BOM.CheckReqFld(appLabel.accountUsage),
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.accountUsage
                      )}
                      showSearch
                      options={accountUsageData}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="tagId"
                    label={<Text strong>{appLabel.tag}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(appLabel.tag)}
                      options={accountTagData}
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      allowClear
                      showSearch
                      key={selectedAccountType} // Force re-render when account type changes
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text strong>{appLabel.manualEntriesAllowed}</Text>}
                    name="manualEntriesAllowed"
                  >
                    <Select
                      options={staticConfig.yesOrNo}
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.manualEntriesAllowed
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="status"
                    label={<Text strong>{appLabel.status}</Text>}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: BOM.CheckReqFld(appLabel.status),
                    //   },
                    // ]}
                  >
                    <Select
                      options={statusData}
                      placeholder={BOM.handlePlaceholderMsg(appLabel.status)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="currencyCode"
                    label={<Text strong>{appLabel.currency}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(appLabel.currency)}
                      options={currencyData}
                      showSearch
                      allowClear
                      onChange={handleCurrencyChange}
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      optionRender={(option) => (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontWeight:
                              option.data.value === "ALL" ? "bold" : "normal",
                            color:
                              option.data.value === "ALL"
                                ? "#92428B"
                                : "inherit",
                          }}
                        >
                          <span>{option.data.label}</span>
                          {option.data.value === "ALL" && (
                            <span style={{ fontSize: "12px", color: "#999" }}>
                              (No currency restriction)
                            </span>
                          )}
                        </div>
                      )}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="description"
                    label={<Text strong>{appLabel.description}</Text>}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "This field is required",
                    //   },
                    // ]}
                  >
                    <TextArea
                      showCount
                      maxLength={1000}
                      placeholder="Enter Account description"
                      style={{
                        height: 120,
                        resize: "none",
                      }}
                    ></TextArea>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Form.Item>
              <Row>
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { newGlAccountAction };

export default connect(mapStateToProps, mapDispatchToProps)(AddGLA0100);
